<template>
  <div v-if="isMounted">
    <div v-if="showWelcomeMessage" class="vx-row no-gutter items-center justify-center">
      <div class="vx-col sm:w-5/6 md:w-2/3 lg:w-1/2 xl:w-2/5 xxl:w-1/3 m-0">
        <div class="vx-row no-gutter items-center justify-center p-6">
          <vx-card class="login-card py-3 px-3">
            <div slot="no-body" class="">
              <div class="vx-col sm:w-full">
                <div class="login-tabs-container">
                  <div class="vx-row m-0">
                    <div class="vx-col w-full p-0" style="min-height: 200px">
                      <!-- MAIN-DIV -->
                      <div class="px-6 pt-5 pb-5">
                        <!-- HEADER -->
                        <div class="vx-row mb-4">
                          <div class="vx-col w-full">
                            <p class="text-2xl card-sub-title">Actualiza tus datos</p>
                          </div>
                        </div>
                        <vs-divider color="dark"></vs-divider>
                        <!-- CONTENT -->
                        <div class="main-form mt-base">
                          <div class="vx-row">
                            <div :class="colClassFull">
                              <p>
                                Por motivos de regulación, es necesario que tu información esté vigente.
                                <br>
                                <br>
                                <span v-if="isMoral">
                                  Si ninguno de tus datos ha cambiado, solo deberás confirmarlos. Si ha habido cambios, solicita que nos pongamos en contacto contigo para apoyarte a actualizarlos.
                                </span>
                                <span v-else>
                                  Si ninguno de tus datos ha cambiado, solo deberás confirmarlos. Si ha habido cambios, actualízalos en la siguiente pantalla.
                                </span>
                              </p>
                            </div>
                          </div>
                          <div class="vx-row">
                            <div class="vx-col md:w-1/2 sm:w-full w-full"></div>
                            <div class="vx-col md:w-1/2 sm:w-full w-full">
                              <vs-button class="w-full mt-4" @click="showWelcomeMessage = false">Continuar</vs-button>
                            </div>
                          </div>
                        </div>
                        <!-- END CONTENT DIV -->
                      </div>
                      <!-- END MAIN-DIV -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div v-else class="vx-row no-gutter items-center justify-center">
      <!-- Inversionistas PM -->
      <template v-if="isMoral">
        <!-- Datos personales -->
        <div class="vx-col w-full lg:w-5/6">
          <investor-pm-resume-data class="mt-base"></investor-pm-resume-data>
        </div>
        <div class="vx-row">
          <div :class="colClassFull">
            <vx-card>
              <p>Si tus datos son correctos, verídicos y están actualizados presiona el botón <br> <b>"Confirmar"</b>,
                de lo contrario presiona <b>"Mis datos han cambiado"</b> para poder <br>
                continuar y nos pondremos en contacto contigo.</p>
              <div class="flex flex-wrap justify-end mt-5">
                <vs-button @click.stop="saveDataForm()">Confirmar</vs-button>
                <vs-button class="ml-5" color="dark" @click.stop="saveDataForm(true)">Mis datos han cambiado</vs-button>
              </div>
            </vx-card>
          </div>
        </div>
      </template>
      <!-- Inversionistas PF -->
      <template v-else>
        <!-- Domicilio -->
        <div v-if="contractLevelData.contract_level != 1" class="vx-col w-full lg:w-5/6">
          <investor-address-data></investor-address-data>
        </div>
        <!-- Datos de contacto -->
        <div class="vx-col w-full lg:w-5/6">
          <investor-contact-data></investor-contact-data>
        </div>
        <!-- Datos de ocupacion -->
        <div class="vx-col w-full lg:w-5/6">
          <investor-occupation-data></investor-occupation-data>
        </div>
        <div class="vx-row">
          <div :class="colClassFull">
            <vx-card class="text-center">
              <div class="flex flex-wrap justify-between">
                <vs-checkbox name="terms" v-model.lazy="confirmData">
                </vs-checkbox>
                <p>Confirmo que la información de mi expediente es verídica y esta actualizada.</p>
              </div>
              <vs-button class="mt-5" :disabled="!confirmData" @click.stop="saveDataForm()">Confirmar</vs-button>
            </vx-card>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import InvestorAddressData from "@/components/investor/profile/InvestorAddressData";
import InvestorOccupationData from "@/components/investor/profile/InvestorOccupationData";
import InvestorContactData from "@/components/investor/profile/InvestorContactData";
import investorInfoHelper from "@/helpers/investorInfoHelper";
import InvestorAboutYouData from "@/components/investor/profile/InvestorAboutYouData";
import InvestorPmResumeData from "@/components/investor/profile/InvestorPmResumeData";


export default {
  name: "InvestorOnboardingUpdatePage",
  mixins: [investorInfoHelper],
  components: {
    InvestorAboutYouData,
    InvestorAddressData,
    InvestorOccupationData,
    InvestorContactData,
    InvestorPmResumeData
  },
  async mounted() {
    this.isMounted = false;
    this.onboardingStepData = await this.getInvestorOnboardingData();
    this.contractLevelData = await this.getInvestorContractLevelData(this.InvestorId);
    this.isMounted = true;
  },
  data() {
    return {
      isMounted: false,
      showWelcomeMessage: true,
      colClassFull: "vx-col w-full mb-5",
      onboardingStepData: {
        onboarding_step: null,
        phone_number: null,
        rfc: null,
        curp: null,
      },
      contractLevelData: null,
      confirmData: false
    }
  },
  computed: {
    isMoral() {
      return this.userIsMoral(this.UserPersonType);
    }
  },
  methods: {
    async saveDataForm(contactNeeded = false) {
      let needContact = contactNeeded;      
      this.showLoading(true, "Guardando información...");
      try {
        let payload = {
          contact_needed: needContact
        };
        await axios.post("/api/v2/investor/confirm-data-profile-updated", payload);
        this.user.investor_profile_info_updated = true;
        this.$router.replace({name: 'inicioInversionista'});
        this.showLoading(false);
      } catch (e) {
        this.showLoading(false);
        this.showError(e);
      }
    },
    showError(e) {
      this.showLoading(false);
      let err = "Ha ocurrido un error con la operación, intente más tarde";
      if (e.response && e.response.data && e.response.data.error) {
        err = e.response.data.error;
      }
      this.errorNotifDialog('Aviso', err);
    },
  }
}
</script>